import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, Link, Slide, AppBar, Toolbar, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import Total from '../Total';
import { ticketAtom, amountToPayAtom, isIOSDeviceAtom } from 'Atoms/Ticket';
import { CallApi, formattingDigitCurrency, paymentDateTime, getTicketAliasFromPathname } from 'utils';
import { staticDataAtom } from 'Atoms/Common';
import { ButtonActions } from 'Components/UI';
import * as Router from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';


function openInNewTab(href) {
  Object.assign(document.createElement('a'), {
    target: '_blank',
    href: href,
  }).click();
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: { ...theme.containerGrid, margin: '1rem', paddingTop: '1rem' },
  title: { ...theme.subTitle, fontSize: '25px', fontWeight: 300 },
  subTitle2: { ...theme.subTitle2 },
  listItem: {
    background: 'white',
    minHeight: '55px',
    borderRadius: '1rem',
    margin: '5px 0',
    paddingLeft: '1rem',
  },
  paddingBottomAndroid: {
    paddingBottom: '2rem',
  },
  paddingBottomIOS: {
    paddingBottom: '.5rem',
  },
  label: {

  },
  label2: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  slabel: {
    fontSize: '0.9rem'
  },
  appBar: {
    top: 'auto',
    bottom: 0,
  },
}));
const PaymentList = ({ paddingBottom }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [ticket] = useAtom(ticketAtom);
  const [staticData, setStaticData] = useAtom(staticDataAtom);
  const [isIOSDevice] = useAtom(isIOSDeviceAtom);
  const [open, setOpen] = React.useState(false);
  const [openTicketDialog, setOpenTicketDialog] = React.useState(false);
  const [selectedPaymentLine, setSelectedPaymentLine] = React.useState(null);
  const [email, setEmail] = React.useState("");
  const [emailValid, setEmailValid] = React.useState(true);
  const [urlTicket, setUrlTicket] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedPaymentLine(null)
    setOpen(false);
  };

  const handleClickOpenTicketDialog = () => {
    setOpenTicketDialog(true);
  };

  const handleCloseTicketDialog = () => {
    setOpenTicketDialog(false);
  };


  const handleClick = async (e, payment_id) => {
    e.preventDefault();
    if (ticket.order.ticketAvailableToPrint) {
      const pathname = window?.location?.pathname;
      const ticketAlias = getTicketAliasFromPathname(pathname);
      const { REACT_APP_TOKEN_API } = process.env;
      let header = {
        Authorization: [REACT_APP_TOKEN_API],
        ticketAlias: ticketAlias,
        paymentId: payment_id
      };
      const result = await CallApi("get", "ticket/demand", "", "", header);
      setUrlTicket(result[0].urlFormated)
      handleClickOpenTicketDialog()
      //openInNewTab(result[0].urlFormated)
    } else {
      setSelectedPaymentLine(payment_id);
      handleClickOpen();
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleAskTicket = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      const pathname = window?.location?.pathname;
        const ticketAlias = getTicketAliasFromPathname(pathname);
        const { REACT_APP_TOKEN_API } = process.env;
        let header = {
          Authorization: [REACT_APP_TOKEN_API],
          ticketAlias: ticketAlias,
          paymentId: selectedPaymentLine,
          email: email
        };
        const result = await CallApi("get", "ticket/demand", "", "", header);
        handleClose();
    } else {
      setEmailValid(false);
    }
  }

  const currency = staticData?.currency;
  const amountFormatting = (amount) => {
    return formattingDigitCurrency(
      amount,
      currency?.countryCode,
      currency?.labelCode,
    );
  };

  const totalPaid = ticket?.order?.payments?.done?.total;

  return (
    <Grid
      container
      className={`${classes.root} ${
        paddingBottom && !isIOSDevice
          ? classes.paddingBottomAndroid
          : classes.paddingBottomIOS
      }`}
    >
      <Grid item xs={12}>
        {/* <Total
          totals={amountPay}
          label={`${t('total')} ${t(':')}`}
          currency={currency}
          styles={{ bold: false }}
        /> */}
        {/*
        <Typography className={classes.subTitle2}>
          {t('payment_already_made')} ({amountFormatting(totalPaid)})
        </Typography>
        */}
        <Typography className={classes.subTitle2}>
          {t('getTheReceipts')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">{t('receiveTheReceipt')}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t('fillYourEmailToReceiveTheReceipt')}
                </DialogContentText>
                <TextField
                  error={!emailValid}
                  autoFocus
                  margin="dense"
                  id="name"
                  label={t("email")}
                  type="email"
                  onChange={(e) => {
                    e.preventDefault();
                    setEmail(e.target.value)
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className={classes.listItem}
                >
                  <Grid item>
                    <Link
                      onClick={(e) => handleClose()}
                    >
                      <ButtonActions fullWidth={false} color="secondary" label={"Annuler"}/>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      onClick={(e) => handleAskTicket(e)}
                    >
                      <ButtonActions fullWidth={false} color="primary" label={"Demander"}/>
                    </Link>
                  </Grid>
                </Grid>
              </DialogActions>
              </Dialog>
              <Dialog fullScreen open={openTicketDialog} onClose={handleCloseTicketDialog} TransitionComponent={Transition}>
                <AppBar color='default' className={classes.appBar}>
                  <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleCloseTicketDialog} aria-label="close">
                      <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                      {t('mySupportingDocument')}
                    </Typography>
                  </Toolbar>
                </AppBar>
                    <iframe src={urlTicket} style={{height: "100%", width: "100%"}}/>
              </Dialog>
        {ticket?.order?.payments?.done?.items.map((line, i) => {
          return (
            <Router.Link
              key={`line-${i}`}
              to={`/ticket/:${ticket.id}/requestTicket/${line.id}`}
              //onClick={(e) => handleClick(e, line.id)}
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className={classes.listItem}
              >

                <Grid item className={classes.label2}>
                  <Typography className={classes.label}>
                    {line.method} {line.label ? `(${line.label})` : ''}
                    {" • "}
                    <b>
                      {amountFormatting(line.amount)}
                      {line.tips ? `(+${amountFormatting(line.tips)}) ` : ''}
                    </b>
                  </Typography>
                  <Typography className={classes.slabel}>
                    {paymentDateTime(line?.date, currency?.countryCode)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid item style={{height: "61px"}}>
                      <svg id="SVGDoc" width="53" height="61" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 53 61"><defs></defs><g><g><title>Path 2</title><path d="M20,20v0l13,10.5v0l-13,10.5v0" fillOpacity="0" fill="#ffffff" strokeDashoffset="0" strokeDasharray="" strokeLinejoin="miter" strokeLinecap="butt" strokeOpacity="1" stroke="#e84249" strokeMiterlimit="20" strokeWidth="2"></path></g></g></svg>
                  </Grid>
                </Grid>

                
              </Grid>
            </Router.Link>
          );
        })}
        </>
      </Grid>
    </Grid>
  );
};

PaymentList.propTypes = {};

export default PaymentList;
